import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem} from '../../../../shared/Models/grid';
import {TextColumn} from '../../../../shared/Models/columns';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {ExactLogService} from '../../../Services/exact-log.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import * as moment from 'moment';


@Component({
  selector: 'app-exact-logs-overview',
  templateUrl: './exact-logs-overview.component.html',
  styleUrls: ['./exact-logs-overview.component.scss']
})
export class ExactLogsOverviewComponent implements OnInit {

  public grid: Grid;
  @ViewChild('modelTooltip', {static: true}) modelTooltip = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    private translateService: TranslateService,
    private broadcastService: BroadcastService,
    private exactLogService: ExactLogService,
  ) {
  }

  ngOnInit() {
    const dateFormat = 'YYYY-MM-DD hh:mm';
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.exact_log.data_type',
          prop: 'dataType',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 200,
          valueFormatter: row => this.getDataType(row),
        },
        <TextColumn>{
          name: 'doctrine.exact_log.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 190,
          valueFormatter: row => row ? 'Successful' : 'Failed',
        },
        <TextColumn>{
          name: 'doctrine.exact_log.date',
          prop: 'createdAt',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 250,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.exact_log.type',
          prop: 'type',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 190,
          valueFormatter: row => row ? 'SEND' : 'RECIEVE',
        },
        <TextColumn>{
          name: 'doctrine.exact_log.message',
          prop: 'message',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.modelTooltip,
        }
      ],
      service: this.exactLogService,
      rememberURL: this.router.url,
      method: 'getLogs',
      defaultSort: 'createdAt',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          type: 'ng-select',
          hasDropdownListFilter: false,
          hasStatus: false,
          hasNormalSearch: false,
          order: [
            {datepickerOrder: 1}
          ],
          searchArrays: [
            {
              index: 3,
              value: {
                value: [
                  {value: 0, label: 'CRM'},
                  {value: 1, label: 'Product'},
                  {value: 2, label: 'Invoice'},
                  {value: 3, label: 'Order'},
                  {value: 4, label: 'Connection'}
                ]
              },
              name: 'dataType',
              width: 20,
              label: 'doctrine.exact_log.data_type',
            }
          ],
        }
      ],
    };

  }

  private getDataType(type) {
    const allTypes = ['CRM', 'Product', 'Invoice', 'Order', 'Connection'];
    return allTypes[type];
  }

}
